import DzenLogo from "@simble/shared/assets/icons/dzen-logo.svg?react";
import LogoFull from "@simble/shared/assets/icons/logo-f.svg?react";
import TelegramLogo from "@simble/shared/assets/icons/telegram-logo.svg?react";
import VkLogo from "@simble/shared/assets/icons/vk-logo.svg?react";

const links1 = [
  {
    label: "Пользовательское соглашение",
    href: "https://simble.in/legal/agreement",
  },
  {
    label: "Политика конфиденциальности",
    href: "https://simble.in/legal/privacy",
  },
  {
    label: "Правила и условия страхования",
    href: "https://www.makc.ru/upload/RULES/02_avtokasko/Rules_09.24.pdf",
  },
  {
    label: "Порядок осуществления прав субъектами персональных данных",
    href: "https://simble.in/personal_data_order",
  },
  {
    label: "Политика обработки персональных данных",
    href: "https://simble.in/personal_data_policy",
  },
];

const supportLinks = [
  { label: "Поддержка", isTitle: true },
  { label: "support@simble.in", isTitle: false },
  { label: "+7 (800) 500-81-47", isTitle: false },
  { label: "Часы работы: с 08:00 до 20:00 по МСК", isTitle: false },
];

const supportItems = supportLinks.map((i) => (
  <p className={`mt-5 block text-white first:mt-0 ${i.isTitle ? "h4" : "body-regular"}`} key={i.label}>
    {i.label}
  </p>
));

const Footer = () => {
  const links = links1.map((i) => (
    <a className="mt-5 block no-underline first:mt-0" href={i.href} key={i.href} rel="noopener noreferrer" target="_blank">
      <p className="body-regular text-white">{i.label}</p>
    </a>
  ));

  const info = (
    <div className="space-y-3">
      <p className="paragraph-base text-white">
        ООО Флекси Драйв не оказывает услуги страхования.
        <br />
        Услуги страхования оказывает: АО «МАКС»
      </p>
      <div className="inline-flex items-center gap-3">
        <span className="whitespace-nowrap text-white">
          <span className="h5 font-extrabold">ИНН:&nbsp;</span>
          <span className="paragraph-base">9729296472</span>
        </span>
        <span className="whitespace-nowrap text-white">
          <span className="h5 font-extrabold">ОГРН:&nbsp;</span>
          <span className="paragraph-base">1207700175814</span>
        </span>
      </div>
      <p className="max-w-[18rem] text-white">
        <span className="h5 font-extrabold">Юр. адрес:&nbsp;</span>
        <span className="paragraph-base">123610, город Москва, Краснопресненская наб, д. 12, подъезд/этаж/помещ. 3/15/Iд часть ком./ком. 8/8б</span>
      </p>
    </div>
  );

  return (
    <footer className="bg-[#4469C6]">
      <div className="mx-auto w-full max-w-[1028px] px-6 pt-[72px] pb-8 md:px-8 md:pb-24">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:gap-24">
          <section className="flex flex-col">
            <LogoFull className="text-white" height={39} width={165} />

            <div className="hidden pt-20 md:block">{info}</div>
          </section>
          <section className="w-65">
            <p className="h4 text-white">Юридическая информация</p>
            {links}
          </section>
          <section className="w-65">
            {supportItems}
            <div className="mt-6 flex items-center gap-4">
              <a href="https://vk.com/simble_ins" rel="noopener noreferrer" target="_blank">
                <VkLogo height={28} width={28} />
              </a>
              <a href="https://dzen.ru/simble" rel="noopener noreferrer" target="_blank">
                <DzenLogo height={28} width={28} />
              </a>
              <a href="https://t.me/simble_in" rel="noopener noreferrer" target="_blank">
                <TelegramLogo height={28} width={28} />
              </a>
            </div>
          </section>
        </div>
        <div className="block pt-[29px] md:hidden md:pt-0">{info}</div>
      </div>
    </footer>
  );
};

export default Footer;
